var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66667 9.20833C7.62266 9.20833 9.20833 7.62266 9.20833 5.66667C9.20833 3.71068 7.62266 2.125 5.66667 2.125C3.71068 2.125 2.125 3.71068 2.125 5.66667C2.125 7.62266 3.71068 9.20833 5.66667 9.20833ZM7.19089 5.42169C7.37173 5.34714 7.4579 5.14013 7.38338 4.95929C7.30887 4.77842 7.10182 4.69225 6.92098 4.76676L4.14247 5.91182C3.96164 5.98634 3.87543 6.19338 3.94999 6.37422C4.0245 6.55506 4.23151 6.64126 4.41239 6.56671L7.19089 5.42169Z",
    fill: "#5571C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3333 14.8753C13.2893 14.8753 14.875 13.2897 14.875 11.3337C14.875 9.37767 13.2893 7.79199 11.3333 7.79199C9.37734 7.79199 7.79166 9.37767 7.79166 11.3337C7.79166 13.2897 9.37734 14.8753 11.3333 14.8753ZM12.7184 12.0155C12.909 12.0593 13.0991 11.9403 13.1429 11.7497C13.1867 11.5591 13.0677 11.369 12.8771 11.3252L9.94829 10.6519C9.75764 10.608 9.5676 10.727 9.52375 10.9177C9.47994 11.1083 9.59894 11.2983 9.78959 11.3422L12.7184 12.0155Z",
    fill: "#5571C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationIcon);
export default __webpack_public_path__ + "static/media/medication_icon.de4dc3f75afb8defe5c26c84d9ece26e.svg";
export { ForwardRef as ReactComponent };